var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button, Form, Input, message, Select } from 'antd';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { history } from 'src/App';
import form from 'src/shared/decorators/form';
import Page from 'src/shared/layout/Page';
import { UserViewModel } from 'src/shared/services/service-proxies';
import services from 'src/shared/services/services';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {};
        _this.roles = [];
        _this.loading = true;
        _this.creating = false;
        _this.password = '';
        _this.save = function () {
            _this.props.form.validateFields(function (errors, values) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!errors) return [3 /*break*/, 4];
                            this.loading = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4 /*yield*/, services.User.save(this.model, this.password)];
                        case 2:
                            _a.sent();
                            message.success('Veri başarıyla güncellendi!');
                            return [3 /*break*/, 4];
                        case 3:
                            this.loading = false;
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
        };
        return _this;
    }
    default_1.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var id, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        id = this.props.match.params.id;
                        if (!(id === 'new')) return [3 /*break*/, 1];
                        this.model = UserViewModel.fromJS({ name: 'Yeni Kullanıcı' });
                        this.creating = true;
                        return [3 /*break*/, 3];
                    case 1:
                        _a = this;
                        return [4 /*yield*/, services.User.get(id)];
                    case 2:
                        _a.model = _c.sent();
                        _c.label = 3;
                    case 3:
                        _b = this;
                        return [4 /*yield*/, services.Role.getAll()];
                    case 4:
                        _b.roles = _c.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    default_1.prototype.render = function () {
        var _this = this;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        return (React.createElement(Page, { buttons: React.createElement("div", null,
                React.createElement(Button, { loading: this.loading, type: "danger", onClick: function () { return history.push('/users/user'); }, style: { marginRight: 8 } }, "\u0130PTAL"),
                React.createElement(Button, { loading: this.loading, type: "primary", onClick: this.save }, "Kaydet")), breadcrumbs: [{ link: '/users/user', text: 'Kullanıcılar' }], loading: this.loading, title: 'Kullanıcı: ' + this.model.name },
            React.createElement("div", { className: "card-header bg-transparent" },
                React.createElement("span", { className: "card-title font-weight-semibold" }, "Kullan\u0131c\u0131 D\u00FCzenle")),
            React.createElement("div", { className: "card-body" },
                React.createElement(Form, { className: "row" },
                    React.createElement(Form.Item, { className: "col-md-6", label: "Ad\u0131" }, getFieldDecorator('name', {
                        initialValue: this.model.name,
                        rules: [{ required: true, message: 'Alan zorunlu!' }]
                    })(React.createElement(Input, { onChange: function (c) { return (_this.model.name = c.target.value); } }))),
                    React.createElement(Form.Item, { className: "col-md-6", label: "Kullan\u0131c\u0131 Ad\u0131", help: "\u00D6zel karakter kullan\u0131lmamal\u0131." }, getFieldDecorator('userName', {
                        initialValue: this.model.userName,
                        rules: [{ required: true, message: 'Alan zorunlu!' }]
                    })(React.createElement(Input, { onChange: function (c) { return (_this.model.userName = c.target.value); } }))),
                    React.createElement(Form.Item, { className: "col-md-6", label: "Email", help: "Ge\u00E7erli bir mail adresi girilmelidir." }, getFieldDecorator('email', {
                        initialValue: this.model.email,
                        rules: [{ required: true, message: 'Alan zorunlu!' }, { type: 'email', message: 'Email adresi geçerli değil!' }]
                    })(React.createElement(Input, { onChange: function (c) { return (_this.model.email = c.target.value); } }))),
                    React.createElement(Form.Item, { className: "col-md-6", label: "Yetkiler" }, getFieldDecorator('roles', {
                        initialValue: this.model.roles,
                        rules: [{ required: true, message: 'Alan zorunlu!' }]
                    })(React.createElement(Select, { mode: "multiple", onChange: function (c) { return (_this.model.roles = c); } }, this.roles.map(function (role) { return (React.createElement(Select.Option, { key: role.id.toString(), value: role.name }, role.name)); })))),
                    React.createElement(Form.Item, { className: "col-md-6", label: "Durum" }, getFieldDecorator('isActive', {
                        initialValue: this.model.isActive ? 1 : 0,
                        rules: [{ required: true, message: 'Alan zorunlu!' }]
                    })(React.createElement(Select, { onChange: function (c) { return (_this.model.isActive = Boolean(c)); } },
                        React.createElement(Select.Option, { value: 1 }, "Aktif"),
                        React.createElement(Select.Option, { value: 0 }, "Pasif")))),
                    React.createElement(Form.Item, { className: "col-md-6", label: "Parola", help: "De\u011Fi\u015Ftirmek istemiyorsan\u0131z bo\u015F b\u0131rak\u0131n." }, getFieldDecorator('password')(React.createElement(Input, { type: "password", onChange: function (c) { return (_this.password = c.target.value); } })))))));
    };
    __decorate([
        observable
    ], default_1.prototype, "model", void 0);
    __decorate([
        observable
    ], default_1.prototype, "roles", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loading", void 0);
    __decorate([
        observable
    ], default_1.prototype, "creating", void 0);
    __decorate([
        observable
    ], default_1.prototype, "password", void 0);
    default_1 = __decorate([
        form,
        observer
    ], default_1);
    return default_1;
}(React.Component));
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/app/users/user/Edit.tsx
// module id = 1284
// module chunks = 0